import { configureStore } from '@reduxjs/toolkit';
import recordsSlice from '../redux/slices/recordsSlice';
import skillsSlice from '../redux/slices/skillsSlice';
import settingsSlice from '../redux/slices/settingsSlice';

export const store = configureStore({
  reducer: {
    records: recordsSlice,
    skills: skillsSlice,
    settings: settingsSlice
  },
});
